module.exports = __webpack_public_path__ + "img/obama.f604e28b.gif";